import { Vector2 } from '@/utilityModels/vector2';

export class MathHelper
{
    // doubleの比較
    private static readonly EPSILON = 0.00001;
    public static equals(a, b)
    {
        return b <= a + this.EPSILON && a - this.EPSILON <= b;
    }

    private static readonly ERROR = 0.01;
    public static equalsWithError(a, b)
    {
        return b < a + this.ERROR && a - this.ERROR < b;
    }


    // 値のクランプ
    public static clamp(value, min, max)
    {
        if(value < min) { return min; }
        if(value > max) { return max; }
        return value;
    }

    // 値を指定桁数までで四捨五入
    public static roundByDigits(value, digits = 0)
    {
        // X.XX に補正
        var powFactor = Math.pow(10, Number(digits));
        var fix = Math.round(Number(value) * powFactor) / powFactor;
        return fix;
    }

    // 多角形同士が内包しているかどうか
    public static isPolygonInPolygon(polygon1 : Array<Vector2>, polygon2 : Array<Vector2>)
    {
        // 一方がもう一方の多角形のすべての頂点を内包するか調べる
        var isInside1 = true;
        for(var i = 0; i < polygon1.length; ++i)
        {
            if(!MathHelper.isPointInPolygon(polygon1[i], polygon2))
            {
                isInside1 = false;
                break;
            }
        }
        var isInside2 = true;
        for(var i = 0; i < polygon2.length; ++i)
        {
            if(!MathHelper.isPointInPolygon(polygon2[i], polygon1))
            {
                isInside2 = false;
                break;
            }
        }

        return isInside1 || isInside2;
    }

    // ある点が多角形に内包されているかどうか
    public static isPointInPolygon(point : Vector2, polygon : Array<Vector2>)
    {
        var p1, p2;
        var isInside = false;
        for(var i = 0; i < polygon.length; ++i)
        {
            var current = i;
            var next = i < polygon.length - 1 ? i + 1 : 0;
            if(polygon[current].x < polygon[next].x) 
            { 
                p1 = polygon[current];
                p2 = polygon[next]; 
            }
            else
            {
                p1 = polygon[next];
                p2 = polygon[current];
            }
            if((p1.x < point.x) == (point.x <= p2.x) && (point.y - p1.y) * (p2.x - p1.x) < (p2.y - p1.y) * (point.x - p1.x))
            {
                isInside = !isInside;
            }
        }
        return isInside;
    }

    // 多角形同士が交差しているかどうか
    public static isPolygonCrossing(polygon1 : Array<Vector2>, polygon2 : Array<Vector2>)
    {
        var isCross = false;
        for(var i = 0; i < polygon1.length; ++i)
        {
            var current1 = i;
            var next1 = i < polygon1.length - 1 ? i + 1 : 0;
            for(var j = 0; j < polygon2.length; ++j)
            {
                var current2 = j;
                var next2 = j < polygon2.length - 1 ? j + 1 : 0;
                
                // すべての線分同士の交差をみて、一つでも交差があればフラグを立てる
                if(MathHelper.isSegmentCrossing(polygon1[current1].x, polygon1[current1].y, polygon1[next1].x, polygon1[next1].y,
                    polygon2[current2].x, polygon2[current2].y, polygon2[next2].x, polygon2[next2].y))
                {
                    isCross = true;
                    break;
                }
            }
        }

        return isCross;
    }

    // 線分同士が交差しているかどうか
    public static isSegmentCrossing(seg1X1, seg1Y1, seg1X2, seg1Y2, seg2X1, seg2Y1, seg2X2, seg2Y2)
    {
        return MathHelper.isSegmentCrossingLine(seg1X1, seg1Y1, seg1X2, seg1Y2, seg2X1, seg2Y1, seg2X2, seg2Y2)
        && MathHelper.isSegmentCrossingLine(seg2X1, seg2Y1, seg2X2, seg2Y2, seg1X1, seg1Y1, seg1X2, seg1Y2);
    }

    // ある線分がある直線に交差しているかどうか
    // 線分: (segX1, segY1) - (segX2, segY2)
    // 直線: (lineX1, lineY1) - (lineX2, lineY2)
    public static isSegmentCrossingLine(segX1, segY1, segX2, segY2, lineX1, lineY1, lineX2, lineY2)
    {
        // 計算上 lineX2 - lineX1 = 0 のときは別に計算する
        if(lineX2 - lineX1 == 0)
        {
            return segX1 <= lineX1 && lineX1 <= segX2;
        }

        // 直線の式をy = ax + bとしたときのa,bを求める
        var a = (lineY2 - lineY1) / (lineX2 - lineX1);
        var b = - (lineY2 - lineY1) / (lineX2 - lineX1) * lineX1 + lineY1;
        // この直線に対して、線分の端が片方が上、片方が下である場合、つまり
        // segY1 >= a * segX1 + b かつ segY2 <= a * segX2 + b
        // segY1 <= a * segX1 + b かつ segY2 >= a * segX2 + b
        // のいずれかが成り立つときに、交差条件を満たす。
        return (a * segX1 + b - segY1) * (a * segX2 + b - segY2) <= 0;
    }
}